import { motion } from "framer-motion";
import * as Icons from "lucide-react";
import { AMENITIES } from "@/data/site";

export const Amenities = () => (
  <section id="amenities" className="py-16 lg:py-24 px-4 sm:px-6 lg:px-12 max-w-7xl mx-auto">
    <div className="grid lg:grid-cols-[1fr_1.4fr] gap-10 items-center">
      <div>
        <span className="text-sm font-semibold uppercase tracking-[0.15em] text-primary">Comfort First</span>
        <h2 className="mt-2 font-serif text-3xl sm:text-4xl font-semibold">Everything You Need for a Restful Stay</h2>
        <p className="mt-3 text-muted-foreground leading-relaxed">
          Thoughtful amenities in every room, backed by friendly round-the-clock service — so your Nagpur trip feels effortless.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-4 gap-3">
        {AMENITIES.map((a, i) => {
          const Icon = Icons[a.icon] || Icons.Check;
          return (
            <motion.div key={a.label}
              initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
              transition={{ duration: 0.4, delay: i * 0.05 }}
              className="rounded-xl border border-border bg-card p-4 flex flex-col items-center text-center gap-2 hover:border-primary/40 hover:shadow-sm transition-all"
            >
              <span className="w-11 h-11 rounded-full bg-primary/10 text-primary flex items-center justify-center"><Icon className="h-5 w-5" /></span>
              <span className="text-xs font-medium">{a.label}</span>
            </motion.div>
          );
        })}
      </div>
    </div>
  </section>
);
